import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-delivery-dialog',
  templateUrl: './delivery-dialog.component.html',
  styleUrls: ['./delivery-dialog.component.scss']
})
export class DeliveryDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeliveryDialogComponent>) { }

  ngOnInit(): void {
  }

  onSelect() {
    this.dialogRef.close('France');
  }
}
